<script setup>

</script>

<template>
  <div
    class="tw-p-4 md:tw-p-6 lg:tw-p-8 tw-border-2 tw-rounded-xl tw-flex tw-gap-4 tw-transition-all tw-group tw-items-start tw-border-neutral-300 tw-bg-white tw-opacity-60"
  >
    <div class="tw-h-6 tw-w-6 tw-shrink-0 tw-border-2 tw-border-neutral-300 tw-rounded-full tw-bg-neutral-100" />

    <div class="tw-flex tw-flex-col tw-gap-2 tw-min-w-0 tw-w-full">
      <p class="tw-text-lg tw-font-semibold tw-m-0 tw-w-full tw-max-w-xs tw-h-8 tw-rounded tw-bg-gradient-to-r tw-from-neutral-200 tw-via-neutral-100 tw-to-neutral-200 tw-animate-shimmer">
        <!-- Title -->
      </p>
      <div class="tw-w-full tw-max-w-sm tw-bg-gradient-to-r tw-from-neutral-200 tw-via-neutral-100 tw-to-neutral-200 tw-h-6 tw-rounded tw-animate-shimmer">
        <!-- Body -->
      </div>
      <div class="tw-w-24 tw-bg-gradient-to-r tw-from-neutral-200 tw-via-neutral-100 tw-to-neutral-200 tw-h-6 tw-rounded-2.5xl tw-animate-shimmer">
        <!-- GA Version -->
      </div>
    </div>
  </div>
</template>
